// extracted by mini-css-extract-plugin
module.exports = {"cover":"_1RVtu46","smallTitle":"_1-QOAxL"};